var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FilterPanel'),_c('Sort',{attrs:{"count":_vm.hotels.length}}),_c('div',{staticClass:"hotels-container"},[_c('HotelList',{attrs:{"list":_vm.hotels}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }